module.exports = __webpack_public_path__ + "static/media/Customer.5e218ead.jpg";